module.exports = __webpack_public_path__ + "img/logoVoodoo@3x.37714ea4.png";